// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._70xVKfwYx{flex:1;display:flex;justify-content:center;align-items:center;padding:40px}._7G5Tb20Ix{list-style-type:none;padding:0px;display:flex;flex-direction:column;flex:1;width:100%;box-shadow:0 3px 6px 0 rgba(0,0,0,0.1)}._3IyQTlzlx{width:100%;border-bottom:solid 1px #DEDEDE;padding-bottom:16px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"no-apps-found-container": "_70xVKfwYx",
	"noAppsFoundContainer": "_70xVKfwYx",
	"list": "_7G5Tb20Ix",
	"divider": "_3IyQTlzlx"
};
module.exports = exports;
